import { render, staticRenderFns } from "./select.package.vue?vue&type=template&id=2ede5766"
import script from "./select.package.vue?vue&type=script&lang=js"
export * from "./select.package.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports